import BaseBarChart from './index'

const BaseBarChartModule = {
  BaseBarChart,
  PerformanceBarChart: BaseBarChart
}

export default BaseBarChartModule
